// Module
var code = "<nlg-panel> <nlg-panel-title> <span translate>title.administration.permissionGroups</span> </nlg-panel-title> <div class=config-params> <nlg-permission-group-create on-register-api=ctrl.filterApi></nlg-permission-group-create> <nlg-permission-group-select on-register-api=ctrl.filterApi></nlg-permission-group-select> </div> </nlg-panel>";
// Exports
module.exports = code;